import { withStyles } from '@material-ui/core';
import SearchAutocomplete from './SearchAutocomplete';
import styles from './SearchAutocomplete.styles';

export default withStyles(styles)(SearchAutocomplete);
